module.exports = __webpack_public_path__ + "static/media/40x40-15.9459e8f8.png";